import { render, staticRenderFns } from "./ToolbarMenu.vue?vue&type=template&id=5cb3f564&"
import script from "./ToolbarMenu.vue?vue&type=script&lang=js&"
export * from "./ToolbarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports